<template>
  <div class="home">
    <AccessManager />
  </div>
</template>

<script>
import AccessManager from "@/components/AccessManager";

export default {
  name: 'AccessView',
  components: {AccessManager},
}
</script>
